<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
// import Layout from "@/components/Layout";
// import vConsole from '@/utils/vconsole';
export default {
  components: {
    // Layout
  },
  mounted() {
    //  vConsole
  },
};
</script>
<style>
#app {
  height: 100%;
}
</style>
